import axios from "axios";

class AuthAPI {
  async postRegister(formData){
    return await axios.post(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/users`,
      { data: formData },
       {
        headers: {
          "Content-Type": "application/json", 
        },
      }
    )
  }
    // PUT /users/unsubscribe  ->  body: { email, reason }
  async putUnsubscribe({ email, reason }) {
    return await axios.put(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/users/unsubscribe`,
      { email, reason },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

}

export default AuthAPI;
